import api from '@/rest-api'

export default {
    login(data) {
        return api.post(`/login`, data)
    }
}